__turbopack_context__.v({
  "collapsed": "accordion-module-scss-module__mIBWyG__collapsed",
  "content": "accordion-module-scss-module__mIBWyG__content",
  "content-wrapper": "accordion-module-scss-module__mIBWyG__content-wrapper",
  "end-area": "accordion-module-scss-module__mIBWyG__end-area",
  "end-area-content": "accordion-module-scss-module__mIBWyG__end-area-content",
  "header": "accordion-module-scss-module__mIBWyG__header",
  "header-item": "accordion-module-scss-module__mIBWyG__header-item",
  "icon-minus": "accordion-module-scss-module__mIBWyG__icon-minus",
  "icon-plus": "accordion-module-scss-module__mIBWyG__icon-plus",
  "item": "accordion-module-scss-module__mIBWyG__item",
  "item-read-more": "accordion-module-scss-module__mIBWyG__item-read-more",
  "main-area": "accordion-module-scss-module__mIBWyG__main-area",
  "title": "accordion-module-scss-module__mIBWyG__title",
});
